'use client';
import { useEffect, useRef, useState } from 'react';
const useGlow = (active = 0) => {
    const glowRef = useRef(null);
    const navRef = useRef(null);
    const [glowX, setGlowX] = useState(active);
    const [activeNav, setActiveNav] = useState(active);
    const prevGlowX = useRef(glowX);
    const glowAnimationSpeed = useRef(0);
    useEffect(() => {
        var _a, _b, _c, _d;
        const activeNavElement = (_a = navRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`li:nth-child(${activeNav}) .nav-item`);
        const activeNavBounds = activeNavElement === null || activeNavElement === void 0 ? void 0 : activeNavElement.getBoundingClientRect();
        const glowBounds = (_b = glowRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        const headerBounds = (_d = (_c = navRef.current) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        const noActiveNav = activeNav === 0;
        if (noActiveNav && glowBounds)
            setGlowX(-glowBounds.width / 2);
        else if (activeNavBounds && glowBounds && headerBounds)
            setGlowX(activeNavBounds.x -
                headerBounds.x -
                glowBounds.width / 2 +
                activeNavBounds.width / 2);
    }, [glowX, activeNav]);
    useEffect(() => {
        if (activeNav !== active)
            setActiveNav(active);
    }, [active]);
    useEffect(() => {
        prevGlowX.current = glowX;
    }, [glowX]);
    glowAnimationSpeed.current = Math.abs(glowX - prevGlowX.current) * 2;
    return {
        activeNav,
        animationDuration: glowAnimationSpeed.current,
        glowRef,
        glowX,
        navRef,
        setActiveNav,
    };
};
export default useGlow;
//# sourceMappingURL=useGlow.js.map